enum PlayerDocumentStatusType {
  IN_REVIEW = 1,
  APPROVED = 2,
  REJECTED = 3,
  PENDING = 4,
}

export default PlayerDocumentStatusType
